import { render, staticRenderFns } from "./ParagraphElement.vue?vue&type=template&id=05b6a47b&scoped=true&"
import script from "./ParagraphElement.vue?vue&type=script&lang=js&"
export * from "./ParagraphElement.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphElement.vue?vue&type=style&index=0&id=05b6a47b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6a47b",
  null
  
)

export default component.exports